declare global {
    interface Window {
        dataLayer?: any[];
    }
}

interface GAEvent {
    event: GoogleAnalyticsCustomEvents;
    parameters: GoogleAnalytics4Parameters;
    userProps: GoogleAnalytics4UserProperties;
}

type GoogleAnalytics4Parameters = {
    element_name: string;
    component_name:
    | 'ApplicationLayout'
    | 'ApplicationHeader'
    | 'BottomSheet'
    | 'Sidebar'
    | 'MainNavigation'
    | 'SubNavigation'
    | 'AppNavigationBar'
    | 'Pager'
    | 'Button'
    | 'Checkbox'
    | 'Clearablelnput'
    | 'LoadMoreButton'
    | 'NumberControl'
    | 'RadioButton '
    | 'Slider'
    | 'Switch'
    | 'ToggleButton'
    | 'Collapse'
    | 'Expander'
    | 'Fade'
    | 'AssetTree'
    | 'AutoSuggest'
    | 'ButtonDropdown'
    | 'Select'
    | 'DatePicker'
    | 'FilePicker'
    | 'TimePicker'
    | 'StatusBar'
    | 'SteppedProgress '
    | 'AnimatedNumber'
    | 'Carousel'
    | 'ContentLoader'
    | 'DataTabs'
    | 'Dialog'
    | 'NoData'
    | 'ErrorState'
    | 'NotFoundState'
    | 'EmptyState'
    | 'ForbiddenState'
    | 'MaintenanceState'
    | 'CustomState'
    | 'NotBookedState'
    | 'StatsWidget'
    | 'TableToolbar'
    | 'TableSearch'
    | 'TableViewToggles'
    | 'TableCardsSorting'
    | 'TableSettingDialog'
    | 'Teaser'
    | 'Timeline'
    | 'AreaChart'
    | 'LineChart'
    | 'BarChart'
    | 'PieChart'
    | 'RadialBarChart'
    | 'Map'
    | 'SingleMapMarker'
    | 'ClusterMapMarker'
    | 'Marker';
    trigger: 'click' | 'visibility';
    flow_name?: string;
    identification_type?: string;
    connection_type?: 'inbound' | 'outbound';
    connection_brand?: 'scania' | 'idem' | 'fleetboard' | 'volvo';
    components?: number;
    method?: string;
    search_term?: string;
    currency?: 'Eur' | 'Usd';
    value?: number;
    page_location?: string;
    page_title?: string;
    ecommerce?: object;
    asset_id?: string;
    rating?: number;
    callback_requested?: 'yes' | 'no';
};

type GoogleAnalytics4UserProperties = {
    login_method?: 'mobile' | 'email';
    account_id?: string;
    tenant?: string; // rio-eu.test, rio-eu.prod, ...
    user_id?: string;
};

// Custom events are always in snake_case
type GoogleAnalyticsCustomEvents =
    | 'click_battery_sidebar_expander'
    | 'show_electric_information'
    | 'click_battery_history_graph_button'
    | 'watch_battery_chart'
    | 'button_pack_details'
    | 'button_pack_arrow'
    | 'button_pack_history';

export const AnalyticsUtils = {
    gaPush: (gaEvent: GAEvent) => {
        const { event, parameters, userProps } = gaEvent;
        if (import.meta.env.MODE === 'development') {
            console.debug('[DEVELOPMENT] skip GA4 Event: ', gaEvent);
            return;
        }

        // The event is handled on the parent FE and on the mFE we will send everything
        if (window.dataLayer) {
            window.dataLayer.push({
                event,
                ...parameters,
                ...userProps,
            });
        }
    },
};
